// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".max-w-1192[data-v-238dc8fe]{margin-left:auto;margin-right:auto;max-width:119.2rem}.horizontal-scroll[data-v-238dc8fe]:focus{outline:2px solid #36c0b6;outline-offset:-2px}.horizontal-scroll[data-v-238dc8fe]{scroll-behavior:smooth}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
